import { differenceInHours, differenceInDays } from 'date-fns';

const formatTimestampToTimeSince = (timestamp = 0) => {
  let lastActiveText = '';
  const now = new Date();

  const hoursDifference = differenceInHours(now, timestamp.toDate());
  const daysDifference = differenceInDays(now, timestamp.toDate());

  if (hoursDifference < 1) {
    lastActiveText = 'Less than an hour ago';
  } else if (hoursDifference < 24) {
    lastActiveText = `${hoursDifference} hour${hoursDifference > 1 ? 's' : ''} ago`;
  } else {
    lastActiveText = `${daysDifference} day${daysDifference > 1 ? 's' : ''} ago`;
  }

  return lastActiveText;
};

export default formatTimestampToTimeSince;
